import { Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { OrderTextForm, SimpleModal } from "src/app/components";
import {
    useAllPrivateRDOptions,
    useContentTypeOptions,
    useWritingTypeOptions,
} from "src/app/hooks";
import { KeywordsTransport } from "src/app/transports/keywords";
import { IActionsModal } from "src/app/types/actionsModal";
import {
    Keyword,
    UpsertKeywordOrderText,
    UpsertKeywordOrderTextSchema,
} from "src/app/types/keywords";
import { WritingType } from "src/app/types/orders/order";

export interface IOrderTextContainer {
    entity: Keyword;
    handleClose?: () => {};
}

const OrderTextContainer = (props: IActionsModal<Keyword>) => {
    const { entity, handleClose = () => {} } = props;
    const [loading, setLoading] = useState(false);
    const { writingTypeOptions, loading: writingLoading } = useWritingTypeOptions([
        WritingType.AI_AUTO,
        WritingType.AI_MANUAL,
        WritingType.WRITE,
    ]);
    const { contentTypeOptions, loading: contentLoading } = useContentTypeOptions();
    const { RDOptions, loading: RDLoading } = useAllPrivateRDOptions();
    const { formatMessage } = useIntl();

    const handleSubmit = async (_values: UpsertKeywordOrderText) => {
        const newEntity = {
            ..._values,
            keyword: entity?.keyword,
        };
        try {
            setLoading(true);
            await KeywordsTransport.createAOrder(newEntity);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handleClose();
        } catch (err: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.orderTextFromKeyword" })}
            handleClose={handleClose}
            loading={loading}
            formId={`upsertOrderByKeyword`}
            showModal={true}
        >
            <Formik
                initialValues={UpsertKeywordOrderTextSchema.getDefault()}
                onSubmit={(values: object) => handleSubmit(values as UpsertKeywordOrderText)}
                validationSchema={UpsertKeywordOrderTextSchema}
            >
                <Form id="upsertOrderByKeyword">
                    <OrderTextForm
                        writingTypeOptions={{
                            options: writingTypeOptions,
                            loading: writingLoading,
                        }}
                        contentTypeOptions={{
                            options: contentTypeOptions,
                            loading: contentLoading,
                        }}
                        RDOptions={{
                            options: RDOptions,
                            loading: RDLoading,
                        }}
                    />
                </Form>
            </Formik>
        </SimpleModal>
    );
};

export default OrderTextContainer;
